import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  signupUser,
  OtpUser,
  loginUser,
  requestPasswordReset,
  confirmPasswordReset,
} from "./ApiService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from "sweetalert2";

const AuthForm = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [isOtpVerification, setIsOtpVerification] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isResetPassword, setIsResetPassword] = useState(false);

  const handleOverlayClick = () => {
    setIsSignUp(!isSignUp);
    setIsOtpVerification(false);
    setIsForgotPassword(false);
    setIsSignedIn(false);
    setIsResetPassword(false);
  };

  const handleForgotPasswordClick = (event) => {
    event.preventDefault();
    setIsForgotPassword(true);
    setIsSignUp(false);
    setIsOtpVerification(false);
    setIsSignedIn(false);
    setIsResetPassword(false);
  };

  const handleBackToSignIn = () => {
    setIsForgotPassword(false);
    setIsSignUp(false);
    setIsOtpVerification(false);
    setIsSignedIn(false);
    setIsResetPassword(false);
  };

  const handleBackToSignUp = () => {
    setIsForgotPassword(false);
    setIsSignUp(true);
    setIsOtpVerification(false);
    setIsSignedIn(false);
    setIsResetPassword(false);
  };

  // --------------------------SIGNUP----------------------

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    mobile: "",
    password: "",
    password2: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Toggle password visibility
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  // Toggle confirm password visibility
  const handleToggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  // Handle form submission
  const handleSignUpClick = async () => {
    // Check if passwords match
    if (formData.password !== formData.password2) {
      Swal.fire({
        title: "Error!",
        text: "Passwords do not match",
        icon: "error",
        confirmButtonText: "Try Again",
      });
      return;
    }

    try {
      const submitFormData = {
        ...formData,
        mobile: `+91${formData.mobile}`, // Prepend +91 to the mobile number
      };
      console.log("Sign up formData:", submitFormData); // Log modified form data for debugging
      const response = await signupUser(submitFormData);
      // Call your signup API function

      Swal.fire({
        title: "Please verify OTP!",
        text: "You have successfully registered. Please verify OTP.",
        icon: "success",
        confirmButtonText: "OK",
      });

      console.log("Registration successful", response);

      // Clear form data
      setFormData({
        username: "",
        email: "",
        mobile: "",
        password: "",
        password2: "",
        address: "",
      });

      setIsSignUp(false); // Proceed to OTP verification
      setIsOtpVerification(true);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        Swal.fire({
          title: "Error!",
          text: "An account with this email or phone number already exists.",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Registration failed. Please try again.",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      }
      console.error("Registration failed", error.response);
    }
  };

  const [shownewPassword, setShownewPassword] = useState(false);
  const [shownewConfirmPassword, setShownewConfirmPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const handleOtpVerification = async () => {
    try {
      const response = await OtpUser({
        otp: otp, // Changed from 'code' to 'passcode'
      });
      Swal.fire({
        title: "OTP Verified successfully!",
        text: "You have successfully OTP Verified. Please log in.",
        icon: "success",
        confirmButtonText: "OK",
      });
      console.log("OTP Verified successfully!", response);

      // Clear fields after verification
      setEmail("");
      setOtp("");
      setIsOtpVerification(false);
      setIsSignedIn(false);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "OTP Verification failed. Please try again.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
      console.error("Error verifying OTP", error);
    }
  };

  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [emailforget, setEmailforget] = useState("");
  const [message, setMessage] = useState("");

  const handleSendResetLinkClick = async () => {
    try {
      const response = await requestPasswordReset(emailforget); // API call to request OTP
      setMessage("Password reset OTP sent to your email.");
      setIsResetPassword(true);
      setIsForgotPassword(false);
      Swal.fire({
        title: "Success!",
        text: "Password reset OTP sent to your email.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      setError("Failed to send OTP. Please check the email.");
      Swal.fire({
        title: "Error!",
        text: "Failed to send OTP. Please try again.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
    }
  };

  const [emailreset, setEmailreset] = useState("");
  const [otpreset, setOtpreset] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const userData = {
        email: emailreset,
        otp: otpreset,
        new_password: newPassword,
        confirm_password: confirmPassword,
      };
      const response = await confirmPasswordReset(userData);

      Swal.fire({
        title: "success!",
        text: "Password reset successful. You can now log in ",
        icon: "success",
        confirmButtonText: "OK",
      });
      setEmailreset("");
      setOtpreset("");
      setNewPassword("");
      setConfirmPassword("");
      setIsSignedIn(false);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Failed to reset password. Please check your details.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
      console.error(
        "Error details: ",
        error.response ? error.response.data : error.message
      );
    }
  };

  function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

  const csrftoken = getCookie("csrftoken");
  const [mobile, setMobile] = useState("");

  const handleSignInClick = () => {
    setError(null);

    const formattedMobile = `+91${mobile}`;

    fetch("https://feniceshieldchemical.bwsoft.in/api/api/login/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrftoken, // Ensure this is correct. Remove if not required.
      },
      body: JSON.stringify({
        mobile: formattedMobile,
        password: password,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          // If response is not OK, parse the response to get error details
          return response.json().then((errorData) => {
            console.error("Response error:", errorData);
            throw new Error(
              errorData.detail || "Invalid credentials. Please try again."
            );
          });
        }
        return response.json();
      })
      .then((data) => {
        // Check for the presence of access token
        if (data.access_token) {
          console.log("Login successful:", data);

          // Save user ID and tokens to local storage
          localStorage.setItem("userId", data.id); // or whatever unique user identifier you need
          localStorage.setItem("accessToken", data.access_token);
          localStorage.setItem("refreshToken", data.refresh_token);

          // Clear inputs and mark the user as signed in
          setMobile(""); // clear mobile state
          setPassword(""); // clear password state
          setIsSignedIn(true); // Set state to indicate the user is signed in
        } else {
          throw new Error("Login failed. No access token received.");
        }
      })
      .catch((error) => {
        console.error("There was a problem with your fetch operation:", error);
        setError("Login failed. Please check your mobile number and password.");
      });
  };
  const rainArray = new Array(100).fill(0);
  return (
    <>
      <div className="banner">
        <img src="assets/img/service.jpg" alt="Service Banner"></img>
      </div>
      <div className="AuthForm-main">
        <div
          className={`AuthForm-main-AuthForm-container ${
            isSignUp ? "AuthForm-main-right-panel-active" : ""
          }`}
        >
          {!isOtpVerification &&
          !isForgotPassword &&
          !isSignedIn &&
          !isResetPassword ? (
            <>
              {isSignUp && (
                <div className="AuthForm-main-form-container AuthForm-main-sign-up-container">
                  <form className="bg-white">
                    <h1>Create Account</h1>

                    <div className="AuthForm-main-infield">
                      <input
                        type="text"
                        placeholder="Name"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                      />
                      <label></label>
                    </div>

                    <div className="AuthForm-main-infield">
                      <input
                        type="email"
                        placeholder="Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <label></label>
                    </div>

                    <div className="AuthForm-main-infield">
                      <input
                        type="tel" // Change to 'tel' for better handling of phone numbers
                        placeholder="Mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                      <label>+91</label>
                    </div>

                    <div className="AuthForm-main-infield">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      <label></label>
                      <span
                        onClick={handleTogglePassword}
                        style={{ cursor: "pointer" }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>

                    <div className="AuthForm-main-infield">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        name="password2"
                        value={formData.password2}
                        onChange={handleChange}
                      />
                      <label></label>
                      <span
                        onClick={handleToggleConfirmPassword}
                        style={{ cursor: "pointer" }}
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    <div className="AuthForm-main-infield">
                      <input
                        type="text"
                        placeholder="Address"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                      />
                      <label></label>
                    </div>

                    <button
                      type="button"
                      onClick={handleSignUpClick}
                      style={{ border: "none" }}
                    >
                      Sign Up
                    </button>
                  </form>
                </div>
              )}

              {/* Sign In Form */}
              {!isSignUp && (
                <div className="AuthForm-main-form-container AuthForm-main-sign-in-container">
                  <form className="bg-white">
                    <h1>LOG IN</h1>

                    <div className="AuthForm-main-infield">
                      <input
                        type="text"
                        placeholder="Mobile Number"
                        name="mobile"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)} // Update to handle mobile input
                      />
                      <label></label>
                    </div>

                    <div className="AuthForm-main-infield">
                      <input
                        type={showPassword ? "password" : "text"}
                        placeholder="Password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <label></label>
                      <span
                        onClick={handleTogglePassword}
                        style={{ cursor: "pointer" }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    {error && <p className="error-message">{error}</p>}

                    <Link
                      to="#"
                      className="AuthForm-main-forgot"
                      onClick={handleForgotPasswordClick}
                    >
                      Forgot your password?
                    </Link>

                    <button type="button" onClick={handleSignInClick}>
                      LOG IN
                    </button>
                  </form>
                </div>
              )}
            </>
          ) : null}

          {isOtpVerification && (
            <div className="AuthForm-main-form-container AuthForm-main-otp-container">
              <form className="bg-white">
                <h1>Verify OTP</h1>

                <div className="AuthForm-main-infield">
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                  <label></label>
                </div>

                {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

                <button type="button" onClick={handleOtpVerification}>
                  Verify OTP
                </button>

                <Link to="#" onClick={handleBackToSignUp}>
                  Back to Sign Up
                </Link>
              </form>
            </div>
          )}

          {/* Forgot Password Form */}
          {isForgotPassword && !isResetPassword && (
            <div className="AuthForm-main-form-container AuthForm-main-forgot-password-container">
              <form className="bg-white">
                <h1>Reset Password</h1>

                <div className="AuthForm-main-infield">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={emailforget}
                    onChange={(e) => setEmailforget(e.target.value)}
                  />
                  <label></label>
                </div>

                <button type="button" onClick={handleSendResetLinkClick}>
                  Send OTP
                </button>

                <Link to="#" onClick={handleBackToSignIn}>
                  Back to Sign In
                </Link>
              </form>
            </div>
          )}

          {/* Reset Password Form */}
          {isResetPassword && (
            <div className="AuthForm-main-form-container AuthForm-main-reset-password-container">
              <form onSubmit={handleResetPasswordSubmit} className="bg-white">
                <h1>Reset Your Password</h1>

                <div className="AuthForm-main-infield">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={emailreset}
                    onChange={(e) => setEmailreset(e.target.value)}
                  />
                  <label></label>
                </div>
                <div className="AuthForm-main-infield">
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otpreset}
                    onChange={(e) => setOtpreset(e.target.value)}
                  />
                  <label></label>
                </div>
                <div className="AuthForm-main-infield">
                  <input
                    // type="password"
                    type={shownewPassword ? "password" : "text"}
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <label></label>
                  <span
                    onClick={handleTogglePassword}
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <div className="AuthForm-main-infield">
                  <input
                    type={shownewConfirmPassword ? "password" : "text"}
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <label></label>
                  <span
                    onClick={handleToggleConfirmPassword}
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                <button type="submit">Submit</button>

                <Link to="#" onClick={handleBackToSignIn}>
                  Back to Sign In
                </Link>
              </form>
            </div>
          )}

          {/* Sign In Confirmation */}
          {isSignedIn && (
            <div className="AuthForm-main-form-container AuthForm-main-sign-in-confirmation-container">
              <h1>Hi User</h1>
              <p>Your account is successfully signed in</p>
              <p>Do you want to log out?</p>
              <button onClick={handleBackToSignIn}>Log Out</button>
            </div>
          )}

          {/* Overlay */}
          <div className="AuthForm-main-overlay-container">
            <div className="AuthForm-main-overlay">
              <div
                className="AuthForm-main-overlay-panel AuthForm-main-overlay-left"
                onClick={handleOverlayClick}
              >
                <div className="authformform-img">
                  {/* Background Image */}
                  <div className="background">
                    <img src="assets/img/amico.png" alt="Building Shield" />
                  </div>

                  {/* Cloud Image */}
                  <div className="cloud">
                    <img src="assets/img/raincloud.png" alt="Cloud" />
                  </div>

                  {/* Continuous Rain Drops */}
                  {rainArray.map((_, index) => (
                    <div
                      className="rain"
                      key={index}
                      style={{
                        left: `${Math.random() * 100}%`, // Randomize horizontal position
                        animationDuration: `${Math.random() * 3 + 2}s`, // Randomize rain speed between 2 and 5 seconds
                      }}
                    >
                      <img src="assets/img/rain.png" alt="Rain" />
                    </div>
                  ))}
                </div>
                <div>
                  <h1>Welcome Back!</h1>
                  <p>
                    To keep connected with us, please login with your personal
                    info
                  </p>
                  <button
                    type="button"
                    onClick={handleOverlayClick}
                    style={{ border: "none" }}
                    className="authform-signbtn"
                  >
                    Sign In
                  </button>
                </div>
              </div>
              <div
                className="AuthForm-main-overlay-panel AuthForm-main-overlay-right authform-img"
                onClick={handleOverlayClick}
              >
                <div className="authformform-img">
                  {/* Background Image */}
                  <div className="background">
                    <img src="assets/img/amico.png" alt="Building Shield" />
                  </div>

                  {/* Cloud Image */}
                  <div className="cloud">
                    <img src="assets/img/raincloud.png" alt="Cloud" />
                  </div>

                  {/* Continuous Rain Drops */}
                  {rainArray.map((_, index) => (
                    <div
                      className="rain"
                      key={index}
                      style={{
                        left: `${Math.random() * 100}%`, // Randomize horizontal position
                        animationDuration: `${Math.random() * 3 + 2}s`, // Randomize rain speed between 2 and 5 seconds
                      }}
                    >
                      <img src="assets/img/rain.png" alt="Rain" />
                    </div>
                  ))}
                </div>
                <div>
                  <h1>Hello, Friend!</h1>
                  <p>
                    Enter your personal details and start your journey with us
                  </p>
                  <button type="button" className="pt-3 pt-md-0 pr-3 pr-md-0">
                    Sign Up
                  </button>
                </div>
              </div>
            </div>
            <button
              className="AuthForm-main-overlay-button"
              onClick={handleOverlayClick}
              style={{ border: "none" }}
            ></button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthForm;
